import React, { useState, useEffect } from "react";
import "./PhoneTable.css";
import DataTable from "../../components/common/DataTable/DataTable";
import { useGetPhonesByUserIdQuery, useGetAllPhonesQuery } from "./phoneSlice";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../auth/authSlice";
import { useSelector } from "react-redux";

const PhoneTable = () => {
  const user = useSelector(selectCurrentUser);

  const [userId, setUserId] = useState(user.userID);

  function getUserId(value) {
    setUserId(value);
  }

  const [type, setType] = useState("today");
  function handleChildClick(value) {
    setType(value);
  }

  // const {data: phones, isLoading, isFetching, isSuccess, isError, error} = useGetPhonesByUserIdQuery(userId);
  const {
    data: phones,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
  } = useGetAllPhonesQuery();

  const [phoneData, setPhoneData] = useState([
    {
      id: 1,
      phoneNumber: "+44 1632 960052",
      date: "1 September 2022",
      time: "12:40",
      numberOfCalls: "23",
      isReachedOut: true,
    },
  ]);

  const [phoneHeading, setPhoneHeading] = useState([
    { name: "Phone No.", selector: (row) => row.destination },
    { name: "Date", selector: (row) => row.callDate },
    { name: "Time", selector: (row) => row.callTime },
    { name: "No. Calls", selector: (row) => row.totalCall },
    { name: "Reached Out", selector: (row) => row.isReachedOut },
  ]);

  useEffect(() => {
    if (phones) {
      const data = phones.ids.map((id) => {
        return phones.entities[id];
      });
      setPhoneData(data);
    }
  }, [phones]);

  const updatedPhoneData = phoneData.map((item) => ({
    ...item,
    isReachedOut: item.isReachedOut ? "Yes" : "No",
  }));

  return (
    <div>
      {isLoading && <LoadingSpinner />}
      <DataTable
        type={"phone"}
        allData={updatedPhoneData}
        tableHeading={phoneHeading}
        itemsPerPage={phoneData.length}
        newOption={0}
        getUserId={getUserId}
        handleFilter={handleChildClick}
        handleEmployee={() => {}}
      />
    </div>
  );
};

export default PhoneTable;
